import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';
import type { ISearchApiResponse } from '~/modules/catalog/types/search';
import type { IPreorderResponse, IPreorderParams } from "~/modules/catalog/types/product";

export default class Catalog extends AbstractFetch {
  private static readonly FILTERS = '';
  private static readonly SEARCH = 'v1/products/search/';
  private static readonly PRODUCTS_BASE = 'v1/products/';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  async getFilters(options: { id: number }): Promise<IResponse<any>> {
    return await this.fetch(Catalog.FILTERS);
  }

  async search(options: { query: string; page: number; count: number }): Promise<IResponse<ISearchApiResponse>> {
    const params = new URLSearchParams();
    params.append('query', options.query);
    params.append('page', String(options.page));
    params.append('count', String(options.count));

    return await this.fetch(Catalog.SEARCH, {
      queryParams: params.toString(),
    });
  }

  async createPreorder(product_id: number, params: IPreorderParams): Promise<IResponse<IPreorderResponse>>{
    const url = Catalog.PRODUCTS_BASE + product_id + '/preorder/';

    return await this.fetch(url, {
      method: 'POST',
      body: params,
    });
  }
}
